module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-page"
  }, [_c('div', {
    staticClass: "progress-head"
  }, [_c('div', {
    staticClass: "progress-title"
  }, [_vm._v("Pregled napretka – " + _vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "progress-sub"
  }, [_vm._v("Grupisano po treningu, po danu uzimamo najbolji rezultat.")])]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "progress-row"
    }, [_c('div', {
      staticClass: "progress-left"
    }, [_c('div', {
      staticClass: "progress-ex"
    }, [_c('div', {
      staticClass: "progress-ex-num"
    }, [_vm._v("#" + _vm._s(group.id))]), _vm._v(" "), _c('div', {
      staticClass: "progress-ex-measure"
    }, [_vm._v(_vm._s(_vm.labelForMeasure(group.measure)))])]), _vm._v(" "), (group.measure !== 'IMAGE' && group.points && group.best && group.last) ? _c('div', {
      staticClass: "progress-stats"
    }, [_c('div', {
      staticClass: "progress-stat"
    }, [_c('div', {
      staticClass: "progress-stat-label"
    }, [_vm._v("Najbolje")]), _vm._v(" "), _c('div', {
      staticClass: "progress-stat-value"
    }, [_vm._v("\n              " + _vm._s(_vm.fmtValue(group.best && group.best.value, group.measure)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "progress-stat"
    }, [_c('div', {
      staticClass: "progress-stat-label"
    }, [_vm._v("Poslednje")]), _vm._v(" "), _c('div', {
      staticClass: "progress-stat-value"
    }, [_vm._v("\n              " + _vm._s(_vm.fmtValue(group.last && group.last.value, group.measure)) + "\n            ")])]), _vm._v(" "), (group.points && group.points.length > 1) ? _c('div', {
      staticClass: "progress-stat"
    }, [_c('div', {
      staticClass: "progress-stat-label"
    }, [_vm._v("Trend")]), _vm._v(" "), _c('div', {
      staticClass: "progress-stat-value",
      class: {
        'up': group.trend > 0,
        'down': group.trend < 0
      }
    }, [_vm._v("\n              " + _vm._s(group.trend > 0 ? '↑' : (group.trend < 0 ? '↓' : '→')) + " " + _vm._s(_vm.abs(group.trend)) + "%\n            ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress-right"
    }, [(group.measure !== 'IMAGE') ? _c('div', {
      staticClass: "progress-chart",
      style: ({
        height: _vm.chartHeight + 'px'
      })
    }, [_c('svg', {
      staticStyle: {
        "width": "100%",
        "height": "auto",
        "display": "block",
        "overflow": "visible"
      },
      attrs: {
        "viewBox": '0 0 ' + _vm.chartWidth + ' ' + _vm.chartHeight,
        "preserveAspectRatio": "none"
      }
    }, [_c('g', {
      staticClass: "grid"
    }, [_vm._l((group.points.length), function(x, i) {
      return _c('line', {
        key: 'gx' + i,
        attrs: {
          "x1": _vm.xPos(i, group.points.length),
          "y1": "0",
          "x2": _vm.xPos(i, group.points.length),
          "y2": _vm.chartHeight
        }
      })
    }), _vm._v(" "), _vm._l((4), function(y, i) {
      return _c('line', {
        key: 'gy' + i,
        attrs: {
          "x1": "0",
          "y1": i * (_vm.chartHeight / 4),
          "x2": _vm.chartWidth,
          "y2": i * (_vm.chartHeight / 4)
        }
      })
    })], 2), _vm._v(" "), _c('polyline', {
      staticClass: "line",
      attrs: {
        "points": _vm.polyPoints(group)
      }
    }), _vm._v(" "), _vm._l((group.points), function(pt, i) {
      return _c('g', {
        key: 'pt' + i,
        staticClass: "point"
      }, [_c('circle', {
        attrs: {
          "cx": _vm.xPos(i, group.points.length),
          "cy": _vm.yPos(pt.value, group.min, group.max),
          "r": "3"
        }
      }), _vm._v(" "), _c('text', {
        staticClass: "pt-label",
        attrs: {
          "x": _vm.xPos(i, group.points.length),
          "y": Math.max(8, _vm.yPos(pt.value, group.min, group.max) - 8),
          "text-anchor": "middle"
        }
      }, [_vm._v("\n                " + _vm._s(_vm.fmtValue(pt.value, group.measure)) + "\n              ")]), _vm._v(" "), _c('title', [_vm._v(_vm._s(pt.dateLabel) + " • " + _vm._s(_vm.fmtValue(pt.value, group.measure)))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "progress-axis",
      style: ({
        padding: '0 ' + _vm.padX + 'px'
      })
    }, _vm._l((group.points), function(pt, i) {
      return _c('div', {
        key: 'xl' + i,
        staticClass: "x-label"
      }, [_vm._v("\n              " + _vm._s(_vm.shortDate(pt.date)) + "\n            ")])
    }), 0)]) : _c('div', {
      staticClass: "progress-images"
    }, _vm._l((group.imagesByDate), function(imgs, date) {
      return _c('div', {
        key: date,
        staticClass: "progress-image-day"
      }, [_c('div', {
        staticClass: "progress-image-date"
      }, [_vm._v(_vm._s(_vm.humanDate(date)))]), _vm._v(" "), _c('div', {
        staticClass: "progress-image-strip"
      }, _vm._l((imgs), function(url, idx) {
        return _c('img', {
          key: date + idx,
          attrs: {
            "src": url,
            "alt": "rezultat"
          }
        })
      }), 0)])
    }), 0)])])
  }), _vm._v(" "), (!_vm.groups.length) ? _c('div', {
    staticClass: "progress-empty"
  }, [_vm._v("Nema rezultata za prikaz.")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-766b9db6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/PersonalProgramResults.vue
// module id = 812
// module chunks = 0